module.exports = __webpack_public_path__ + "img/figure5.0bd2e9f0.png";